module.exports = __webpack_public_path__ + "img/process2.67cb69d4.png";